import React, {useEffect, useState} from 'react';
import styles from './TourCur.module.css';
import TourCurForm from "../TourCurForm/TourCurForm";
import {fetchTournaments, fetchActiveFriendlyTournaments, fetchHasActiveFriendlyTournaments} from "../../api/api";
import Spinner from "../Spinner/Spinner";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

const TourCur = ({ initialTournamentId }) => {
    const [tournaments, setTournaments] = useState([]);
    const [selectedTournament, setSelectedTournament] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    // Turnieje towarzyskie nie trafiają na publiczną listę. Monitor klubowy startuje pod
    // sztywnym /tournaments i ma tylko air mouse, więc odsłania je dyskretna kropka.
    // Uwaga: to zasłona, nie zabezpieczenie — endpoint jest publiczny.
    const [friendlyTournaments, setFriendlyTournaments] = useState(null);
    // Samo true/false — kropki nie ma, gdy nie ma czego odsłaniać. Tytuły dopiero po kliknięciu,
    // żeby gość, który nic nie kliknął, nie dostawał ich w odpowiedzi.
    const [hasFriendly, setHasFriendly] = useState(false);

    useEffect(() => {
        const fetchActiveTournaments = async () => {
            try {
                const result = await fetchTournaments('ACTIVE');
                if (result.success) {
                    const sortedTournaments = result.data.sort((a, b) => {
                        return new Date(b.tournamentDate) - new Date(a.tournamentDate);
                    });
                    setTournaments(sortedTournaments);
                    if (initialTournamentId) {
                        const found = sortedTournaments.find(t => t.id === initialTournamentId);
                        if (found) setSelectedTournament(found);
                    }
                    setIsLoading(false)
                }
            } catch (error) {
                console.error("Failed to fetch active tournaments", error);
                setError("Błąd pobrania danych");
                setIsLoading(false);
            }
        };

        fetchActiveTournaments();
    }, [initialTournamentId]);

    useEffect(() => {
        const checkFriendly = async () => {
            const result = await fetchHasActiveFriendlyTournaments();
            setHasFriendly(result.success && result.data === true);
        };
        checkFriendly();
    }, []);

    const handleReturnToList = () => {
        setSelectedTournament(null);
    };

    const handleRevealFriendly = async () => {
        const result = await fetchActiveFriendlyTournaments();
        setFriendlyTournaments(result.success ? result.data : []);
    };

    if (isLoading) return <Spinner size={"large"}/>;
    if (error) return <ErrorMessage error={error}/>;

    return (
        <div>
            {selectedTournament && <TourCurForm tournament={selectedTournament} isArchived={false} onReturn={handleReturnToList}/>}
            <div className={styles.tournaments}>
                {!selectedTournament && tournaments.length > 0 ? (
                    tournaments.map((tournament) => (
                        <button
                            key={tournament.id}
                            className={styles.tournamentButton}
                            onClick={() => setSelectedTournament(tournament)}
                        >
                            {`${tournament.title}`}
                        </button>
                    ))
                ) : (
                    !selectedTournament && <p className={styles.noTournamentsMessage}>Brak trwających turniejów.</p>
                )}

                {!selectedTournament && friendlyTournaments !== null && (
                    friendlyTournaments.length > 0
                        ? friendlyTournaments.map((tournament) => (
                            <button
                                key={tournament.id}
                                className={styles.tournamentButton}
                                onClick={() => setSelectedTournament(tournament)}
                            >
                                {`${tournament.title}`}
                            </button>
                        ))
                        : <p className={styles.noTournamentsMessage}>Brak trwających turniejów towarzyskich.</p>
                )}
            </div>

            {!selectedTournament && hasFriendly && (
                <button
                    type="button"
                    data-testid="friendly-dot"
                    className={styles.friendlyDot}
                    onClick={handleRevealFriendly}
                    aria-label="Turnieje towarzyskie"
                />
            )}
        </div>
    );
};

export default TourCur;
